import { render, staticRenderFns } from "./addRout.vue?vue&type=template&id=543cbc25&scoped=true"
import script from "./addRout.vue?vue&type=script&lang=js"
export * from "./addRout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543cbc25",
  null
  
)

export default component.exports